import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { LobbyService } from "src/app/services/lobby/lobby.service";
import { Navigator } from "../../menu/navigator";
import { CashierContentService } from "src/app/services/cashier/cashier-content.service";
import { EventsService } from "src/app/services/event/event.service";
import { PromotionDetailPage } from "../promotion-detail/promotion-detail.component";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { Campaign } from "src/app/interfaces/campaign-interface";

@Component({
  selector: "app-promotion-card",
  templateUrl: "./promotion-card.component.html",
  styleUrls: ["./promotion-card.component.scss"],
})
export class PromotionCardComponent implements OnInit {
  isLoggedIn = false;

  @Input() promoData: Campaign;
  @Input() cardConfig: { listType: string };

  @Output() openPromoDetail: EventEmitter<Campaign> = new EventEmitter();

  constructor(
    private navigator: Navigator,
    private cashierContentService: CashierContentService,
    public events: EventsService,
    public userSession: UserSessionService
  ) {}

  ngOnInit() {
    this.userSession.isAuthenticated().then((res) => {
      if (res) {
        this.isLoggedIn = true;
      } else {
        this.isLoggedIn = false;
      }
    });
  }

  moreInfo(promoData:Campaign) {
    this.openPromoDetail.emit(promoData);
  }

  onCouponButtonClick(item: Campaign) {
    this.navigator.navigateTo(
      "RedeemBonusCodeComponent",
      {},
      { bonusCode: item.campaign_category }
    );
  }

  public openSignupOptions(offer) {
    this.navigator.navigateTo(
      "SignupStepOneComponent",
      {},
      { signupcode: offer.campaign_code }
    );
  }

  public openLogin() {
    this.navigator.navigateTo("LoginComponent");
  }
}
